'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRoleType = hasRoleType;

var _ObjectUtils = require('@omniex/onx-common-js/lib/utils/ObjectUtils');

function hasRoleType(user, roleType) {
  return (0, _ObjectUtils.get)(user, 'roles', []).map(function (role) {
    return role.type;
  }).includes(roleType);
}

exports.default = {
  hasRoleType: hasRoleType
};